import { apiClient, handleError } from '../../../../api/ApiClient';

export const getPostcodes = (search, successCallback) => dispatch => {
  return apiClient
    .post('/postal-code', { search, page: 0, limit: 50 })
    .then(res => successCallback(res.data))
    .catch(err => dispatch(handleError(err)));
};
